// src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getStorage } from "firebase/storage";
/* 🔐 Auth (added for admin panel) */
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  GoogleAuthProvider,
} from "firebase/auth";

// --- Firebase config ---
const firebaseConfig = {
  apiKey: "AIzaSyDMyweOsU2ZMHydciXb3LYQRWW4pnUdsuE",
  authDomain: "sushe-portfolio.firebaseapp.com",
  projectId: "sushe-portfolio",
  // ✅ Correct bucket format is <project-id>.appspot.com
  storageBucket: "sushe-portfolio.appspot.com",
  messagingSenderId: "334223316292",
  appId: "1:334223316292:web:1b2e8b043fb1c74a05f311",
};

// Initialize app once
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Firestore + offline cache
const db = getFirestore(app);
try {
  enableIndexedDbPersistence(db);
} catch (err) {
  if (process.env.NODE_ENV === "development") {
    console.warn("Firestore persistence not enabled:", err?.code || err);
  }
}

// Storage (shared instance)
const storage = getStorage(app);

/* =========================
   🔐 Auth setup (NEW)
   - Persists login across tabs/sessions
   - Exports `auth` and `googleProvider`
   ========================= */
const auth = getAuth(app);
// Keep users signed in between refreshes
setPersistence(auth, browserLocalPersistence).catch((err) => {
  if (process.env.NODE_ENV === "development") {
    console.warn("Auth persistence not set:", err?.code || err);
  }
});
const googleProvider = new GoogleAuthProvider();
// Optional: pick Google account dialog each time
// googleProvider.setCustomParameters({ prompt: "select_account" });

export { app, db, storage, auth, googleProvider };

/* If you use local emulators, uncomment:
import { connectFirestoreEmulator } from "firebase/firestore";
import { connectStorageEmulator } from "firebase/storage";
import { connectAuthEmulator } from "firebase/auth";
if (process.env.NODE_ENV === "development") {
  connectFirestoreEmulator(db, "localhost", 8080);
  connectStorageEmulator(storage, "localhost", 9199);
  connectAuthEmulator(auth, "http://localhost:9099");
}
*/
